// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const emailKeys = {
  all: ['email'] as const,
  emailSuppressionResults: (emails: string[]) => {
    return [...emailKeys.all, 'emailSuppressionResults', emails] as const;
  },
};

export default emailKeys;
